export default "__VITE_ASSET__Di0Ye$sH__"